<footer class="app-footer">
  <div class="footer-container">
    <!-- Main Footer Content -->
    <div class="footer-main">
      <!-- Brand Section -->
      <div class="footer-brand">
        <div class="brand-logo-wrapper">
          <img src="assets/images/logos/FTR-Color-Wide.svg" alt="FARTURK Registry" class="footer-logo">
        </div>
        <p class="brand-description">
          Faricimab tedavisi alan hastaların takibi için geliştirilmiş, KVKK uyumlu hasta kayıt sistemi.
        </p>
        <div class="brand-badges">
          <div class="badge">
            <span class="md3-icon">verified_user</span>
            <span>KVKK Uyumlu</span>
          </div>
          <div class="badge">
            <span class="md3-icon">cloud_done</span>
            <span>Firebase Güvenliği</span>
          </div>
        </div>
      </div>

      <!-- Navigation Sections -->
      <div class="footer-navigation">
        @for (section of footerSections; track section.title) {
          <div class="footer-nav-section">
            <div class="nav-section-header">
              <span class="md3-icon">{{ section.icon }}</span>
              <h3>{{ section.title }}</h3>
            </div>
            <ul class="nav-section-links">
              @for (link of section.links; track link.route) {
                <li>
                  @if (link.external) {
                    <a [href]="link.route" class="nav-link" target="_blank" rel="noopener noreferrer">
                      @if (link.icon) {
                        <span class="md3-icon">{{ link.icon }}</span>
                      }
                      <span>{{ link.label }}</span>
                      <span class="md3-icon external-icon">open_in_new</span>
                    </a>
                  } @else {
                    <a [routerLink]="link.route" class="nav-link" routerLinkActive="active">
                      @if (link.icon) {
                        <span class="md3-icon">{{ link.icon }}</span>
                      }
                      <span>{{ link.label }}</span>
                    </a>
                  }
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>

    <!-- Divider -->
    <div class="footer-divider"></div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-left">
        <p class="copyright">
          <span class="md3-icon">copyright</span>
          {{ currentYear }} FARTURK Registry. Tüm hakları saklıdır.
        </p>
        <p class="version">
          <span class="md3-icon">info</span>
          v{{ appVersion }} - Angular {{ angularVersion }} + Firebase {{ firebaseVersion }}
        </p>
      </div>

      <div class="footer-bottom-right">
        <!-- Social Links -->
        <div class="social-links">
          @for (social of socialLinks; track social.url) {
            <a [href]="social.url"
               class="social-link"
               target="_blank"
               rel="noopener noreferrer"
               [attr.aria-label]="social.ariaLabel">
              <span class="md3-icon">{{ social.icon }}</span>
            </a>
          }
        </div>

        <!-- Scroll to Top Button -->
        <button
          class="scroll-top-btn"
          (click)="scrollToTop()"
          aria-label="Başa dön">
          <span class="md3-icon">arrow_upward</span>
        </button>
      </div>
    </div>

    <!-- Legal & Compliance Notice -->
    <div class="footer-legal">
      <p class="legal-notice">
        <span class="md3-icon">gavel</span>
        Bu sistem, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve GDPR uyumlu olarak tasarlanmıştır.
        Hasta bilgileri AES-256-GCM şifreleme ile korunmaktadır.
      </p>
    </div>
  </div>
</footer>
